// Mock data for Expat Landing Page

export const services = [
  {
    id: 1,
    title: "Finance & Banking",
    description: "Complete guidance on opening bank accounts, understanding German banking systems, and managing your finances effectively in Germany.",
    icon: "Banknote",
    features: ["Bank Account Setup", "Financial Planning", "Tax Optimization", "Currency Management"]
  },
  {
    id: 2,
    title: "Insurance Solutions",
    description: "Navigate the complex German insurance landscape with expert guidance on mandatory and optional insurance coverage.",
    icon: "Shield",
    features: ["Health Insurance", "Liability Insurance", "Life Insurance", "Professional Coverage"]
  },
  {
    id: 3,
    title: "Wealth Building",
    description: "Strategic wealth accumulation tailored for expats with short, medium, and long-term investment strategies.",
    icon: "TrendingUp",
    features: ["Investment Planning", "Retirement Savings", "Portfolio Management", "Asset Protection"]
  },
  {
    id: 4,
    title: "Real Estate Investment",
    description: "From finding the right property to optimal financing and portfolio integration for stable returns and value appreciation.",
    icon: "Home",
    features: ["Property Search", "Financing Solutions", "Investment Analysis", "Portfolio Integration"]
  }
];

export const hrBenefits = [
  {
    id: 1,
    title: "Comprehensive Support",
    description: "End-to-end relocation assistance covering all financial and administrative aspects for your international employees.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Neutral & Independent",
    description: "Unbiased advice with access to all market products ensuring the best solutions for your employees.",
    icon: "Scale"
  },
  {
    id: 3,
    title: "Digital Management Tool",
    description: "Organize and track your expat employees' relocation process through our dedicated HR platform.",
    icon: "Monitor"
  },
  {
    id: 4,
    title: "Streamlined Process",
    description: "Reduce administrative burden with our structured approach and dedicated support team.",
    icon: "Zap"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Chen",
    role: "Software Engineer",
    location: "Singapore → Munich",
    quote: "The comprehensive support made my move to Germany seamless. Every financial aspect was handled professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Williams",
    role: "HR Director",
    company: "Tech Corp International",
    quote: "As an HR department, we finally found a reliable partner for our expat relocations. The digital tool is a game-changer.",
    rating: 5
  },
  {
    id: 3,
    name: "Carlos Rodriguez",
    role: "Finance Manager",
    location: "Madrid → Berlin",
    quote: "Clear, structured financial planning that actually considers the unique needs of expats. Highly recommended.",
    rating: 5
  }
];

export const faqData = [
  {
    id: "faq-1",
    question: "How does the consultation process work?",
    answer: "Our process starts with an initial 45-minute consultation where we assess your situation and goals. We then develop a customized concept tailored to your needs as an expat in Germany, covering all relevant financial and administrative areas."
  },
  {
    id: "faq-2",
    question: "What makes your service different for expats?",
    answer: "We specialize in the unique challenges expats face in Germany - from understanding the local banking system to navigating insurance requirements and building wealth while considering international tax implications. We provide guidance in English and have extensive experience with cross-border financial planning."
  },
  {
    id: "faq-3",
    question: "How much does the consultation cost?",
    answer: "The initial consultation is free. Our services are compensated through standard market provisions already included in the products - no additional fees for you. You receive professional advice without extra cost."
  },
  {
    id: "faq-4",
    question: "Do you work with companies and HR departments?",
    answer: "Yes, we offer specialized services for companies relocating employees to Germany. This includes comprehensive support packages and a digital management tool for HR departments to organize and track their expat employees' integration process."
  },
  {
    id: "faq-5",
    question: "What if I already have some insurance or accounts set up?",
    answer: "We review your existing contracts and accounts, integrate them into your overall financial strategy, and identify optimization opportunities. We work with approximately 95% of all relevant providers in the market."
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Initial Consultation",
    description: "45-minute discovery call to understand your situation, goals, and needs as an expat in Germany.",
    duration: "Week 1"
  },
  {
    id: 2,
    title: "Strategy Development",
    description: "We create a comprehensive, customized plan covering all relevant areas without any effort from your side.",
    duration: "Week 1-2"
  },
  {
    id: 3,
    title: "Concept Presentation",
    description: "Clear presentation of your personalized strategy with actionable recommendations and next steps.",
    duration: "Week 2"
  },
  {
    id: 4,
    title: "Q&A & Refinement",
    description: "Address questions, clarify details, and finalize your concept based on your feedback.",
    duration: "Week 2"
  },
  {
    id: 5,
    title: "Implementation",
    description: "Begin implementation with access to our services and exclusive network of providers.",
    duration: "Week 2-3"
  },
  {
    id: 6,
    title: "Ongoing Support",
    description: "Regular check-ins to review your strategy, adapt to changes, and ensure long-term optimization.",
    duration: "Ongoing"
  }
];
